import Vacorder from '@/service/vacorder'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getvendorvacs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vacorder.getvendorvacs(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getvacorders(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vacorder.getvacorders(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getorderablevacs(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vacorder.getorderablevacs(payload), {
        type: 'list',
        success,
        fail
      })
    },
    addvacorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vacorder.addvacorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    trialvacorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vacorder.trialvacorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    extendvacorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vacorder.extendvacorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deletevacorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vacorder.deletevacorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    stopvacorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vacorder.stopvacorder(payload), {
        type: 'action',
        success,
        fail
      })
    },
    resumevacorder(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Vacorder.resumevacorder(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
